<div class="row mt-5" *ngIf="planSummary">
  <div class="col-12">
    <app-card-container>
      <div class="row">
        <div class="col-12">
          <div class="header-text mb-4">Plan Summary</div>
        </div>
      </div>
      <div class="row" *ngFor="let detail of planSummary; let i = index">
        <div class="col-12"><label class="summary-bold-text">{{detail.itemName}}:</label> {{detail.value[0].column1}}</div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <label class="tax-text">* Applicable Taxes May Apply</label>
        </div>
        <div class="col-lg-12 col-12">
          <label class="fee-text">* Price includes a one-time, nonrefundable processing fee of {{coverageLevel?.adminFee | currency:'USD': 'symbol':'1.0-0'}}</label>
        </div>
      </div>
    </app-card-container>
  </div>
</div>